import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { ForeignBusinessPoliticalModel } from './types';
import foreignBusinessPoliticalItemValidator from './validators/item';

const foreignBusinessPoliticalValidator: ValidateJSModel<ForeignBusinessPoliticalModel> = {
  HasForeignPolitical: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignPolitical?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessPoliticalItemValidator },
      };
    }

    return {};
  },
};

export default foreignBusinessPoliticalValidator;
